import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { CredusButton, CredusText } from 'ui';

import { SuccessIcon } from '../../../../../assets/images/svgs';
import { Refetch } from '../TestData';

interface TestUploadSuccessProps {
  showSuccess: boolean;
  successMessage: string;
  setShowSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: Refetch;
}

const TestActionSuccess = ({
  refetch,
  showSuccess,
  setShowSuccess,
  successMessage,
}: TestUploadSuccessProps) => {
  const handleCancel = () => {
    setShowSuccess(false);
  };
  const handleClick = () => {
    refetch();
    setShowSuccess(false);
  };

  return (
    <Modal title="" open={showSuccess} footer="" onCancel={handleCancel}>
      <Container>
        <SuccessIcon />
        <CredusText size="xl" weight="medium">
          Success!
        </CredusText>
        <CredusText size="md" weight="regular" align="center">
          {successMessage}
        </CredusText>
        <CredusButton variant="secondary" onClick={handleClick}>
          Close
        </CredusButton>
      </Container>
    </Modal>
  );
};

export default TestActionSuccess;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 4rem 2rem;
`;
